import { loadFlights, fetchEarlyTicketBlacklist } from './services'
import { processFlightsResult } from "./flights.module";

const getDefaultState = () => {
  return {
    flights: null,
    passengers: null,
    flightsWithSeatMessages: [],
    containsSeatBookableAfterIssue: null,
    hasEarlyTicketIssueBlacklist: null,
  };
};

const state = getDefaultState();

const getters = {
  getFlights: (state) => {
    return state.flights && state.flights[0] ? state.flights : null;
  },
  getFlightsWithSeatingMessages: (state) => {
    return state.flightsWithSeatMessages ? state.flightsWithSeatMessages : []
  },
  getDoFlightsIncludeSeatBookableAfterIssue: (state) => {
    return state.containsSeatBookableAfterIssue ? state.containsSeatBookableAfterIssue : false
  },
  getHasEarlyTicketIssueBlacklist: (state) => {
    return state.hasEarlyTicketIssueBlacklist ? state.hasEarlyTicketIssueBlacklist : false
  }
};

const actions = {
  async loadFlightsAction({ commit, rootState }) {
    const booking = rootState.booking.booking
    // Irish booking number starts with R or r
    const irish = rootState.auth.userData && rootState.auth.userData.bookno ? rootState.auth.userData.bookno.charAt(0).toUpperCase() === 'R' : false
    if (!booking || !booking.booking_information || !booking.booking_itinerary) {
      return null
    }
    // Seating messages come back on the booking itself, so they must be committed
    // before the trip-ended / vendor_list checks below. Travelfusion (Ryanair)
    // bookings have no GDS locators, and one-way bookings can have vtdate_return
    // set to the outbound date, both of which were leaving the seating modal
    // with no flights at all.
    commit('flightsWithSeatingMessagesReceived', booking.booking_itinerary.flights || [])
    if (booking.booking_information.vtdate_return && new Date() > new Date(booking.booking_information.vtdate_return)) {
      return null
    }
    if (!booking.booking_information.vendor_list) {
      // no GDS locators, so there are no live seat numbers to look up
      return null
    }
    commit('flightsWithSeatingMessagesReceived', booking.booking_itinerary.flights)
    const [res, blacklist] = await Promise.all([
      loadFlights({ vendor_list: booking.booking_information.vendor_list, irish }),
      fetchEarlyTicketBlacklist(),
    ])
    commit('earlyTicketBlacklistAirlines', { flights: booking.booking_itinerary.flights, blacklist })
    const flights = processFlightsResult(res)
    commit('flightsReceived', flights)
  },
  resetStateAction({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  flightsReceived(state, flights) {
    state.flights = flights
  },
  resetState(state) {
    Object.assign(state, getDefaultState())
  },
  flightsWithSeatingMessagesReceived(state, flightsWithMsgs) {
    state.flightsWithSeatMessages = flightsWithMsgs
    const containsSeatsBookableAfterIssue = flightsWithMsgs.some((flt) => {
      return flt && flt.flightMessages && flt.flightMessages.some((msg) => {
        if (!msg.code || !msg.canIssueEarly) return false;
        if (!flt.optiondate) return true;
        const optionDate = new Date(flt.optiondate);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return optionDate >= today;
      })
    })
    state.containsSeatBookableAfterIssue = containsSeatsBookableAfterIssue
  },
  earlyTicketBlacklistAirlines(state, { flights, blacklist }) {
    const airlineCodes = (flights || []).map((flt) => flt.suppliercode).filter(Boolean)
    const blacklistCodes = (blacklist || []).map((item) => item.airlineCode)
    const uniqueAirlineCodes = [...new Set(airlineCodes)]

    const hasEarlyTicketIssueBlacklist = uniqueAirlineCodes.some((airline) =>
      blacklistCodes.includes(airline),
    )
    state.hasEarlyTicketIssueBlacklist = hasEarlyTicketIssueBlacklist
  }
}

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
